import _ from 'lodash'
import axios from 'axios'

import { SLOW_REQUEST_CONFIG } from '../util/operationProgressUtil'
import {
  OPCAO_RESP_TECNICA_NAO_RESP_AGIR,
  OPCAO_RESP_TECNICA,
  OPCAO_RESP_POR_AGIR
} from '../reducers/filtrosReducer'
import { temUnidadesAtuaisSelecionadas } from '../controllers/unidadesController'

export const axiosWrapper = axios

export const VISAO_POR_AUDITOR_RECUPERADA = '@itensPorVisaoActions/VISAO_POR_AUDITOR_RECUPERADA'
export const ITENS_POR_VISAO_RECUPERADOS = '@itensPorVisaoActions/ITENS_POR_VISAO_RECUPERADOS'
export const DESCARTAR_ITENS_POR_VISAO = '@itensPorVisaoActions/DESCARTAR_ITENS_POR_VISAO'
export const DESCARTAR_VISAO_E_ITENS_POR_VISAO =
  '@itensPorVisaoActions/DESCARTAR_VISAO_E_ITENS_POR_VISAO'
export const VISAO_RECUPERADA_ATUALIZADA = '@itensPorVisaoActions/VISAO_RECUPERADA_ATUALIZADA'

export const visaoPorAuditorUrl = (codigoUsuario) =>
  `/bff/processos/visao-por-auditor${codigoUsuario ? `?codigoUsuario=${codigoUsuario}` : ''}`

export const VISAO_POR_AUDITOR_AGRUPADOR = 'visaoPorAuditorAgrupador'

export const criarVisaoItensFiltrosDTO = ({ unidadesAtuais, responsabilidadeUnidade }) => {
  validarPreCondicoesFiltro(unidadesAtuais)
  let filtrosProcessoDTO = {}
  filtrosProcessoDTO = determinarCodigosUnidades(unidadesAtuais, filtrosProcessoDTO)
  filtrosProcessoDTO = determinarResponsabilidadeUnidade(
    responsabilidadeUnidade,
    filtrosProcessoDTO
  )
  return filtrosProcessoDTO
}

export const getVisaoUrl = ({ visao, codigoUsuario }) => {
  validarPreCondicoesVisao(visao)
  switch (visao) {
    case VISAO_POR_AUDITOR_AGRUPADOR:
      return visaoPorAuditorUrl(codigoUsuario)
    default:
      throw new Error(`${visao} não implementada!`)
  }
}

const determinarCodigosUnidades = (unidadesAtuais, filtrosProcessoDTO) => {
  let codigosUnidades = []
  if (temUnidadesAtuaisSelecionadas(unidadesAtuais)) {
    codigosUnidades = _.concat(codigosUnidades, _.keys(unidadesAtuais))
  }
  return { ...filtrosProcessoDTO, codigosUnidades }
}

const determinarResponsabilidadeUnidade = (responsabilidadeUnidade, filtrosProcessoDTO) => {
  switch (responsabilidadeUnidade) {
    case OPCAO_RESP_TECNICA:
      return { ...filtrosProcessoDTO, responsabilidadeUnidade: 'RESP_TECNICA' }
    case OPCAO_RESP_POR_AGIR:
      return { ...filtrosProcessoDTO, responsabilidadeUnidade: 'RESP_AGIR' }
    case OPCAO_RESP_TECNICA_NAO_RESP_AGIR:
      return { ...filtrosProcessoDTO, responsabilidadeUnidade: 'RESP_TECNICA_NAO_RESP_AGIR' }
    default:
      return filtrosProcessoDTO
  }
}

const validarPreCondicoesVisao = (visao) => {
  if (!visao) {
    throw new Error('visao não deve ser null!')
  }
}

const validarPreCondicoesFiltro = (unidadesAtuais) => {
  if (!temUnidadesAtuaisSelecionadas(unidadesAtuais)) {
    throw new Error('unidadesAtuais são obrigatórios!')
  }
}

const determinarVisaoRecuperada = ({ visao }) => {
  switch (visao) {
    case VISAO_POR_AUDITOR_AGRUPADOR:
      return VISAO_POR_AUDITOR_RECUPERADA
    default:
      throw new Error(`${visao} não implementada!`)
  }
}

export const recuperarVisao =
  (filtros, callback, isSlowRequest = true) =>
    (dispatch) =>
      axios.post(
        getVisaoUrl(filtros),
        criarVisaoItensFiltrosDTO(filtros),
        isSlowRequest && SLOW_REQUEST_CONFIG
      )
        .then((response) => {
          dispatch({
            type: determinarVisaoRecuperada(filtros),
            payload: response.data
          })
          if (callback) {
            callback(response.data.informacoesAuditor.codigoUsuario)
          }
        })

export const determinarVisaoAtualizada = () => ({
  type: VISAO_RECUPERADA_ATUALIZADA
})

export const descartarItensPorVisao = () => ({
  type: DESCARTAR_ITENS_POR_VISAO
})
